<div class="row ml-0 mr-0 mb-4 mt-1" *ngIf="newMyProperty">
  <div
    class="col-lg-12"
    style="background-color: #fff; padding: 0px 0px; border-radius: 15px; border: 1px solid #e7e7e7"
  >
    <div class="row">
      <div class="col-md-2 col-sm-4 col-12 pr-md-0">
        <ng-container *ngIf="isLoadingImageTrue">
          <div class="mt-5">
            <div class="flex_center"><mat-spinner [diameter]="20" class="mr-3"></mat-spinner></div>
          </div>
        </ng-container>

        <ng-container *ngIf="!isLoadingImageTrue">
          <div class="image_container">
            <img
              *ngIf="defaultPropertyImage"
              class="img-fluid mx-auto property-image p-md-3"
              [src]="defaultPropertyImage"
              height="130px"
            /></div
        ></ng-container>

        <ng-container
          *ngIf="!defaultPropertyImage && !isLoadingImageTrue && isStreetViewAvailable"
          class="img-fluid mx-auto property-image p-md-3"
        >
          <div class="p-md-3">
            <app-street-view
              style="min-height: 200px !important"
              [defaultPlace]="defaultPlace"
              [isMyHomeAccess]="true"
              (streetViewAvailable)="onStreetViewAvailable($event)"
              (streetViewEvent)="setStreetView($event)"
            >
            </app-street-view>
          </div>
        </ng-container>

        <ng-container
          *ngIf="!defaultPropertyImage && !isLoadingImageTrue && isStreetViewAvailable == false"
          class="img-fluid mx-auto property-image p-md-3"
        >
          <div class="p-md-3">
            <app-birds-eye-view [defaultPlace]="defaultPlace" [containerHeight]="'140'"></app-birds-eye-view>
          </div>
        </ng-container>
      </div>

      <div class="col-md-7 col-sm-8 col-12 pl-md-0 pl-4">
        <h5 class="mt-3" [propertyAddress]="address.fullAddress" (click)="isHideDealButton()">
          {{ address.streetAddress }}, {{ address.city }}, {{ address.state }} {{ address.zip }}
        </h5>
        <p class="mb-1">
          {{ address.bedCount | IsValueExist }}<span> Bed</span> • {{ address.bathCount | IsValueExist
          }}<span> Bath</span> • {{ address.livingAreaSize | number: '1.0-0' | IsValueExist }}<span> sq.ft</span> •
          {{ address.lotSize | number: '1.0-0' | IsValueExist }}<span> sq.ft</span>
        </p>
        <img
          class="mb-3"
          style="height: 48px; cursor: pointer"
          src="../../../../assets/images/map.svg"
          (click)="openMapDialog()"
        />
      </div>
      <div class="col-md-3 col-sm-12 col-12" *ngIf="this.source != 'equityAnalysis'">
        <p class="mt-4 weather d-flex align-items-center">
          <img class="pr-2 weather-icon" src="~/../../assets/images/weather.png" width="28" alt="Weather Icon" />
          <span class="temperature">{{ currentTemperature }}&#176;F</span>
          <span class="mx-1">•</span>
          <span class="condition">{{ weatherCondition }}</span>
        </p>
      </div>
    </div>
  </div>
</div>

<ng-template #mapDialog>
  <h2 mat-dialog-title>Map View</h2>

  <mat-dialog-content>
    <ng-container class="img-fluid mx-auto property-image p-md-3">
      <div class="clearfix"></div>
      <div class="row BirdStreetView">
        <div class="col-md-12 mb-3">
          <mat-radio-group aria-label="Select a view" (change)="onViewChange($event)" #radioGroup="matRadioGroup">
            <mat-radio-button value="streetView" checked>Street View </mat-radio-button>
            <mat-radio-button class="pl-2" value="birdsEyeView">Bird's Eye View</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12" [hidden]="isStreetView">
          <app-birds-eye-view
            [defaultPlace]="defaultPlace"
            (birdsEyeViewEvent)="setBirdsEyeView($event)"
          ></app-birds-eye-view>
        </div>
        <div class="col-lg-12" [hidden]="!isStreetView">
          <app-street-view [defaultPlace]="defaultPlace" (streetViewEvent)="setStreetView($event)"></app-street-view>
        </div>
      </div>
    </ng-container>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" (click)="closeMapDialog()">Close</button>
  </mat-dialog-actions>
</ng-template>

<div class="row myH_DetailsWrap" *ngIf="!newMyProperty && !source">
  <div class="col-lg-4">
    <div class="myH_propimg">
      <div class="section_base scroller1">
        <div class="col-sm-12">
          <div class="row">
            <img
              class="img-fluid mx-auto property-image"
              [src]="listingImageBaseUrl + '?ListingId=' + (address.lstListingId || 'null') + '&imageName=1&height=219'"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-8">
    <div class="row">
      <div class="col-lg-8">
        <section class="myH_name">
          <h3 [propertyAddress]="address.fullAddress">{{ address.streetAddress }}</h3>
          <p [propertyAddress]="address.fullAddress">{{ address.city }}, {{ address.state }},{{ address.zip }}</p>
          <p class="myH_type">{{ address.propertySubType }}</p>
        </section>
      </div>
      <div class="col-lg-4">
        <section class="myH_spl">
          <div>
            <span></span>
            <p>{{ address.bedCount | IsValueExist }}</p>
          </div>
          <div>
            <span></span>
            <p>{{ address.bathCount | IsValueExist }}</p>
          </div>
          <div>
            <span></span>
            <p>{{ address.livingAreaSize | number: '1.0-0' | IsValueExist }}<span> sq.ft</span></p>
          </div>
          <div>
            <span></span>
            <p>{{ address.lotSize | number: '1.0-0' | IsValueExist }}<span> sq.ft</span></p>
          </div>
        </section>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 table-responsive">
        <table class="w-100 myh_val">
          <tr>
            <td class="tab-border myH_proprate">
              <label
                >Purchase Price
                <button
                  class="myHedit_btn"
                  style="margin-left: 8px"
                  [ngbPopover]="purchaseValueContent"
                  #purchaseValuePopover="ngbPopover"
                  [popoverTitle]="purchaseValueTitle"
                  placement="bottom"
                  [autoClose]="false"
                >
                  &#9998;
                </button></label
              >
              <h4>{{ purchaseValue | currency: 'USD':'symbol':'0.0-0' | IsValueExist }}</h4>
              <p *ngIf="soldDate">Sold: {{ soldDate | date: 'mediumDate' | IsValueExist }}</p>
              <p *ngIf="!soldDate">&nbsp;</p>
              <ng-template #purchaseValueContent>
                <form [formGroup]="spendForecastForm">
                  <mat-form-field>
                    <input
                      type="number"
                      class="text-center"
                      floatLabel="never"
                      matInput
                      formControlName="customPurchaseValue"
                      autocomplete="off"
                    />
                  </mat-form-field>
                  <button mat-icon-button aria-label="Cancel" matTooltip="Cancel">
                    <i
                      class="material-icons"
                      (click)="revertValue('customPurchaseValue')"
                      style="font-size: 20px; color: #60697a"
                    >
                      restart_alt
                    </i>
                  </button>
                  <button mat-icon-button aria-label="Ok" matTooltip="Ok">
                    <i
                      class="material-icons"
                      (click)="saveValue('customPurchaseValue')"
                      style="font-size: 20px; color: #4caf50"
                    >
                      done
                    </i>
                  </button>
                </form>
              </ng-template>
              <ng-template #purchaseValueTitle
                >Edit Purchase Price
                <button mat-icon-button aria-label="Ok" matTooltip="close">
                  <i
                    class="material-icons"
                    style="font-size: 20px; color: #bdbdd0"
                    (click)="purchaseValuePopover.close()"
                  >
                    close
                  </i>
                </button></ng-template
              >
            </td>
            <td class="Appreciation">
              <h4 style="margin-bottom: 5px" *ngIf="!isNegativeOrder(appreciateRatio)">
                <img class="pr-1" src="../../assets/images/increase.png" />{{
                  appreciateRatio ? appreciateRatio.toFixed() : '0'
                }}
                %
              </h4>
              <h4 style="margin-bottom: 5px; color: #c41414 !important" *ngIf="isNegativeOrder(appreciateRatio)">
                <img class="pr-1" src="../../assets/images/down.png" />{{
                  appreciateRatio ? appreciateRatio.toFixed() : '0'
                }}
                %
              </h4>
              <p>Appreciation</p>
            </td>
            <td class="tab-border">
              <label>PropMix Estimate</label>
              <ng-container *ngIf="propmixValue != 0; else zeroPropmixValue">
                <h4>{{ propmixValue | currency: 'USD':'symbol':'0.0-0' | IsValueExist }}</h4>
              </ng-container>
              <ng-template #zeroPropmixValue>
                <h4>--</h4>
              </ng-template>
              <p>&nbsp;</p>
            </td>
            <td class="sign">
              <h4>-</h4>
            </td>
            <td class="tab-border">
              <label>Loan Balance (Est.)</label>
              <ng-container *ngIf="loanBalance != 0; else zeroBalance">
                <h4>{{ loanBalance | currency: 'USD':'symbol':'0.0-0' }}</h4>
              </ng-container>
              <ng-template #zeroBalance>
                <h4>--</h4>
              </ng-template>

              <p class="a-analyze" (click)="onMortgageScroll($event)">Save On Mortgages</p>
            </td>
            <td class="sign">
              <h4>=</h4>
            </td>
            <td class="cal-balance">
              <label>Your Net Equity</label>
              <h4>{{ netEquity | currency: 'USD':'symbol':'0.0-0' | IsValueExist }}</h4>
              <p class="total-analyze" (click)="onEquityScroll($event)">Unlock your Equity</p>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>
